import { render, staticRenderFns } from "./JobTabs.vue?vue&type=template&id=41ff60ba&scoped=true&"
import script from "./JobTabs.vue?vue&type=script&lang=js&"
export * from "./JobTabs.vue?vue&type=script&lang=js&"
import style0 from "./JobTabs.vue?vue&type=style&index=0&id=41ff60ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ff60ba",
  null
  
)

export default component.exports